export default __webpack_public_path__ + "static/media/relax.bc73c965.svg";